/****
 * Layout wrapper for admin pages that renders
 * the appropriate admin route content.
 */
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div className="bg-[var(--app-bg)]">
      <Outlet />
    </div>
  );
};

export default AdminLayout;
